<template>
  <div class="sip_sh_w">
    <div class="sip_sh"
      data-sharer="facebook"
      :data-url="url"
    >
      <div v-html="fb" />
    </div>
    <div
      class="sip_sh"
      data-sharer="vk"
      :data-caption="caption"
      :data-title="title"
      :data-url="url"
    >
      <div v-html="vk" />
    </div>
    <div
      class="sip_sh"
      data-sharer="okru"
      :data-url="url"
      :data-title="title"
    >
      <div v-html="ok" />
    </div>
  </div>
</template>
<script>
import { fb, vk, ok } from '../views/shareIcons'

export default {
  name: 'Share',
  data() {
    return {
      url: 'https://ria.ru/ips/gpn-game/',
      title: 'ЗАПРАВЛЯЕМ СПГ :)',
      caption: 'Примерьте на себя роль его капитана',
      fb, vk, ok,
    }
  },
  props: [
    'body',
    'id',
  ],
  mounted() {
    this.url=`https://ria.ru/ips/gpn-game/${+this.id-1}.html`
    this.caption = this.body
  },
  methods: {
  }
}
</script>

<style lang="stylus">
.sip_sh_w
  display: flex
.sip_sh
  cursor pointer
  margin-right 10px
</style>